/* [04] V2 | Non-destructive document rails. Headings are existing content. */
(() => {
  'use strict';
  const $all = (node, sel) => Array.from(node.querySelectorAll(sel));
  const clean = (value) => (value || '').replace(/\s+/g, ' ').trim();
  function label(text, className) {
    const el = document.createElement('p');
    el.className = className;
    el.textContent = text;
    return el;
  }
  function meta(title, scope) {
    const el = document.createElement('aside');
    el.className = 'ed04-meta';
    el.setAttribute('aria-label', 'Document context');
    el.append(label('[04] / ' + scope, 'ed04-rail-label'));
    el.append(label(clean(title), 'ed04-meta-title'));
    return el;
  }
  function toc(headings, id) {
    const list = headings.filter((h) => h && clean(h.textContent));
    if (!list.length) return null;
    const aside = document.createElement('aside');
    aside.className = 'ed04-toc';
    const nav = document.createElement('nav');
    nav.setAttribute('aria-label', 'On this page');
    aside.append(label('ON THIS PAGE', 'ed04-rail-label'), nav);
    list.slice(0, 32).forEach((heading) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = clean(heading.textContent).slice(0, 110);
      if (/H[3-6]/i.test(heading.tagName)) btn.classList.add('ed04-deep');
      btn.addEventListener('click', () => {
        const bar = document.querySelector('#header-component');
        const tabbar = heading.closest('.legal-hub-04')?.querySelector('.legal04__navigation');
        const headerBottom = bar && getComputedStyle(bar).position !== 'static' ? Math.max(0, bar.getBoundingClientRect().bottom) : 0;
        const navHeight = tabbar ? tabbar.getBoundingClientRect().height : 0;
        const wrapper = heading.closest('.page-wrapper');
        const scroller = wrapper && /auto|scroll/.test(getComputedStyle(wrapper).overflowY) ? wrapper : window;
        const scrollTop = scroller === window ? window.scrollY : scroller.scrollTop;
        const origin = scroller === window ? 0 : scroller.getBoundingClientRect().top;
        const y = scrollTop + heading.getBoundingClientRect().top - origin - headerBottom - navHeight - 20;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        heading.setAttribute('tabindex', '-1');
        heading.focus({preventScroll:true});
        scroller.scrollTo({top:Math.max(0,y),behavior:reducedMotion?'auto':'smooth'});
      });
      nav.append(btn);
    });
    return aside;
  }
  function initLegals() {
    $all(document,'.legal04__document-grid:not(.ed04-ready)').forEach((grid,index) => {
      const heads = $all(grid,'.legal04__document-title, .legal04__body h2, .legal04__body h3, .legal04__body h4');
      const rail = toc(heads,'legal-'+index);
      if (!rail) return;
      grid.append(rail);
      grid.classList.add('ed04-ready');
    });
  }
  function initReference() {
    $all(document,'.manual04__reference-grid:not(.ed04-ready)').forEach((grid,index) => {
      const root = grid.closest('.manual04--reference');
      const heads = [root?.querySelector('.manual04__title'), ...$all(grid,'.manual04__reading h2,.manual04__reading h3,.manual04__reading h4')];
      const rail = toc(heads,'reference-'+index);
      if (!rail) return;
      grid.append(rail);
      grid.classList.add('ed04-ready');
    });
  }
  function initNativePolicy() {
    $all(document,'.legal-page-04 .shopify-policy__container:not(.ed04-ready)').forEach((root,index) => {
      const title = root.querySelector('.shopify-policy__title h1');
      const body = root.querySelector('.shopify-policy__body');
      if (!title || !body) return;
      const headings = [title,...$all(body,'h2,h3,h4')];
      const rail = toc(headings,'policy-'+index);
      if (!rail) return;
      root.insertBefore(meta(title.textContent,'DOCUMENT'),body);
      root.append(rail);
      root.classList.add('ed04-ready');
    });
  }
  function initSystems() {
    $all(document,'.manual-page-04 .ds04__systems:not(.ed04-ready)').forEach((root,index) => {
      const articles = $all(root,':scope > .ds04__system');
      if (!articles.length) return;
      const heads = articles.map((a) => a.querySelector('h2')).filter(Boolean);
      const rail = toc(heads,'systems-'+index);
      if (!rail) return;
      const heading = root.closest('.ds04')?.querySelector('h1');
      root.prepend(meta(heading?.textContent || 'Drop Systems','SYSTEMS'));
      root.append(rail);
      root.classList.add('ed04-ready');
    });
  }
  function initDropPolicy() {
    $all(document,'.manual-page-04 section.dp:not(.ed04-ready)').forEach((root,index) => {
      const articles = $all(root,':scope > .dp__rule');
      if (!articles.length) return;
      const rail = toc(articles.map((a) => a.querySelector('h3')).filter(Boolean),'drop-policy-'+index);
      if (!rail) return;
      const grid = document.createElement('div');
      grid.className = 'ed04-policy-grid';
      const reader = document.createElement('div');
      reader.className = 'ed04-policy-reading';
      root.insertBefore(grid,articles[0]);
      articles.forEach((article) => reader.append(article));
      grid.append(meta(root.querySelector('.dp__title')?.textContent || 'Drop Policy','RULES'),reader,rail);
      root.classList.add('ed04-ready');
    });
  }

  /* Standard, narrative Shopify pages such as About. Do not wrap special
     cost-breakdown widgets, tables, forms or size charts. */
  function initGenericNarrative() {
    $all(document,'#MainContent.ed04-info-page .page-content:not(.ed04-generic-ready)').forEach((page,index)=>{
      const rte=page.querySelector('rte-formatter');
      if(!rte || rte.querySelector('#pb04,table,form,iframe,input,textarea'))return;
      const headings=$all(rte,'h2,h3,h4');
      if(headings.length<2)return;
      const rail=toc(headings,'narrative-'+index);
      if(!rail)return;
      const grid=document.createElement('div');
      grid.className='ed04-generic-grid';
      const reader=document.createElement('div');
      reader.className='ed04-generic-reading';
      const title=document.querySelector('#MainContent.ed04-info-page .section-content-wrapper h1')?.textContent || document.title.split('|')[0];
      page.insertBefore(grid,rte);
      reader.append(rte);
      grid.append(meta(title,'STUDIOS'),reader,rail);
      page.classList.add('ed04-generic-ready');
    });
  }

  function init() {
    initLegals();
    initReference();
    initNativePolicy();
    initSystems();
    initDropPolicy();
    initGenericNarrative();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
  document.addEventListener('shopify:section:load',init);
})();